/* eslint-disable no-console */
import _get from 'lodash/get';

class ReducerSagaRegistry {
    constructor() {
        this.reducers = {};
        this.sagas = {};
        this.updateStore = null;
        this.runSaga = null;
        this.cancelSaga = null;
    }

    get registry() {
        return {
            reducers: this.reducers,
            sagas: this.sagas,
        };
    }

    initReducers = (initialReducers = {}, updateStore) => {
        this.reducers = {
            persistent: initialReducers,
            subscribers: {},
            injected: {},
        };
        this.updateStore = updateStore;
    };

    injectReducer = (reducersInfo) => {
        const reducersToInject = Array.isArray(reducersInfo) ? reducersInfo : [reducersInfo];
        let toUpdate = false;

        const { persistent, injected, subscribers } = this.reducers;

        reducersToInject.forEach((reducerToInject) => {
            const { name, reducer, requestedBy } = reducerToInject;
            if (!persistent[name]) {
                subscribers[name] = subscribers[name] || [];
                subscribers[name].push(requestedBy);

                if (!injected[name]) {
                    injected[name] = reducer;
                    toUpdate = true;
                }
            }
        });
        if (this.updateStore && toUpdate) {
            this.updateStore({ ...persistent, ...injected });
        }
    };

    rejectReducer = (reducersInfo) => {
        const reducersToReject = Array.isArray(reducersInfo) ? reducersInfo : [reducersInfo];
        let toUpdate = false;

        const { persistent, injected, subscribers } = this.reducers;

        reducersToReject.forEach((reducerToReject) => {
            const { name, requestedBy } = reducerToReject;

            if (!persistent[name]) {
                subscribers[name] = subscribers[name] || [];
                const index = subscribers[name].indexOf(requestedBy);
                index !== -1 && subscribers[name].splice(index, 1);

                if (!subscribers[name].length && injected[name]) {
                    injected[name] = null;
                    console.log(`Rejecting reducer ${name}`);
                    toUpdate = true;
                }
            }
        });

        if (this.updateStore && toUpdate) {
            this.updateStore({ ...persistent, ...injected });
        }
    };

    initSagas = (rootSagas = {}, injectHandler, rejectHandler) => {
        this.sagas = {
            persistent: rootSagas,
            subscribers: {},
            injected: {},
        };
        this.runSaga = injectHandler;
        this.cancelSaga = rejectHandler;
    };

    injectSaga = (sagasDescriptors) => {
        const sagasToInject = Array.isArray(sagasDescriptors)
            ? sagasDescriptors
            : [sagasDescriptors];

        const { persistent, injected, subscribers } = this.sagas;

        sagasToInject.forEach(({ name, saga, requestedBy }) => {
            if (!persistent[name]) {
                subscribers[name] = subscribers[name] || [];
                subscribers[name].push(requestedBy);

                if (!injected[name] && this.runSaga) {
                    injected[name] = this.runSaga(saga);
                }
            }
        });
    };

    rejectSaga = (sagasDescriptors) => {
        const sagasToReject = Array.isArray(sagasDescriptors)
            ? sagasDescriptors
            : [sagasDescriptors];

        const { persistent, injected, subscribers } = this.sagas;

        sagasToReject.forEach(({ name, requestedBy }) => {
            if (!persistent[name]) {
                subscribers[name] = subscribers[name] || [];
                const index = subscribers[name].indexOf(requestedBy);
                index !== -1 && subscribers[name].splice(index, 1);

                if (!subscribers[name].length && _get(injected, [name, 'id']) && this.cancelSaga) {
                    console.log(`Rejecting saga ${name}`);
                    this.cancelSaga(injected[name]);
                    injected[name] = null;
                }
            }
        });
    };
}

export default ReducerSagaRegistry;
